module.exports = __webpack_public_path__ + "img/genba_btn1.c8ea078a.png";